import {
  getReferralCode,
  syncReferralRewardWithRollback,
} from "@/cart/maticReferralReward";
import type {
  AddItemContext,
  AddMaticOptions,
  CartStateGetSet,
} from "@/cart/types";
import { MATIC_VARIANT_ID } from "@/consts/shopify";

export const addMatic = ({ get, set }: CartStateGetSet) => {
  const syncReward = syncReferralRewardWithRollback({ get, set });

  return async (
    context?: AddItemContext,
    quantity?: number,
    options?: AddMaticOptions,
  ) => {
    const { codeOverride, variantId = MATIC_VARIANT_ID } = options ?? {};
    const referralCode = getReferralCode(get, get().cart, codeOverride);

    if (referralCode) {
      await get().ensureReferralCode(referralCode);
    }

    const cartBeforeMaticAdd = get().cart;

    await get().addItem(variantId, context, quantity);

    const cart = get().cart;

    if (!cart) {
      throw new Error("addMatic: Adding Matic to cart failed");
    }

    if (!getReferralCode(get, cart, codeOverride)) {
      return cart;
    }

    return syncReward(cartBeforeMaticAdd, cart, codeOverride);
  };
};
